import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles(() => ({
  paymentPageBox: {
    width: "100%",
    height: "fit-content",
  },
  paymentPageBoxLeft: {
    padding: "30px 40px",
    width: "50%",
    backgroundColor: "#FCFCFC",
    minHeight: "100vh",
    maxHeight: "fit-content",
  },
  paymentPageBoxRight: {
    width: "50%",
    padding: "30px 40px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    maxHeight: "fit-content",
  },
  paymentPageBoxBackBtn: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Inter",
    gap: 8,
    fontSize: 16,
    fontWeight: 500,
    color: "#171717",
    marginBottom: 10,
  },
  paymentPageBoxLogo: {
    width: 160,
    marginTop: 20,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    "& > h4": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 20,
      fontSize: 24,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#101828",
      textAlign: "center",
      margin: 0,
      marginBottom: 32,
      "& svg": {
        color: "#000000",
      },
    },
  },
  inputs: {
    marginBottom: 4,
  },
  inputFieldStyle: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#404040",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "10px 14px",
      height: 44,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      background: "#FFF",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      "& input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",
        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "#171717",
          transition: "background-color 5000s ease-in-out 0s",
        },
        "&::placeholder": {
          color: "#737373",
        },
      },
    },
  },
  payBtn: {
    marginTop: 14,
    width: "100%",
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  agreeTermsCondText: {
    margin: 0,
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#84949E",
    "& a": {
      color: "#FFAF4A",
      textDecoration: "none",
    },
  },
  // kept for backward compatibility
  centered: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    marginTop: rem(50),
  },
  back: {
    position: "absolute",
    top: rem(50),
    left: rem(50),
    fontSize: rem(16),
    fontFamily: "Inter",
    fontWeight: 500,
    "@media (max-width: 1024px)": {
      top: rem(100),
    },
  },
}));
